import { render, staticRenderFns } from "./OmwStats.vue?vue&type=template&id=52f86e90&"
import script from "./OmwStats.vue?vue&type=script&lang=js&"
export * from "./OmwStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports